import { useAuth } from './useAuth'

/**
 * Joriy foydalanuvchi <b>platforma egasi</b>mi — ya'ni GLOBAL ko'rinish
 * doirasiga egami.
 *
 * <h2>Nega ROL nomi bo'yicha emas</h2>
 * `GET /api/me` rol kodlarini UMUMAN qaytarmaydi — faqat huquqlar va
 * doiralar (`MeResponse`). Bu ataylab: rollar bu tizimda dinamik
 * (`docs/04-ROLES.md` §1) va kod hech qayerda `SUPERADMIN` degan satrga
 * bog'lanmaydi.
 *
 * Doira esa modelda bor va u aynan shu savolga javob beradi:
 * `ScopeType.GLOBAL` — "Barcha tenantlar. Faqat platforma egasi".
 *
 * <h2>⚠️ Bu QULAYLIK, xavfsizlik EMAS</h2>
 * Backend har so'rovda ikkala shartni ham qayta tekshiradi: `tenant.*`
 * huquqi VA GLOBAL doira
 * (`TenantAdminServiceImpl#requirePlatformOwner`). Bu yerdagi tekshiruv
 * faqat bosib bo'lmaydigan menyu havolasini chizmaslik uchun.
 *
 * <h2>Nega huquq tekshiruvi bilan BIRGA ishlatiladi</h2>
 * Ikkalasi boshqa savolga javob beradi: huquq — "nima qila oladi",
 * doira — "kimga nisbatan". Faqat huquqni tekshirish yetmaydi, chunki
 * rollar dinamik va tashkilot admini o'ziga `tenant.create` li rol
 * yasab olishi mumkin edi; faqat doirani tekshirish ham yetmaydi,
 * chunki GLOBAL doiradagi rolning huquqlari cheklangan bo'lishi mumkin.
 */
export function useIsPlatformOwner(): boolean {
  const { user } = useAuth()
  return user?.scopes.some((scope) => scope.type === 'GLOBAL') ?? false
}
